import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { usePolicyLines } from "@/hooks/usePolicyLines";

interface PolicyTypeFormProps {
  formData: {
    name: string;
    description: string;
    sort_order: number;
    policy_line_id: string;
  };
  onSubmit: (e: React.FormEvent) => void;
  onChange: (data: Partial<PolicyTypeFormProps['formData']>) => void;
  onCancel: () => void;
  mode: 'create' | 'edit';
}

export const PolicyTypeForm = ({
  formData,
  onSubmit,
  onChange,
  onCancel,
  mode
}: PolicyTypeFormProps) => {
  const { data: policyLines, isLoading: isPolicyLinesLoading } = usePolicyLines();

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="name">Name</Label>
        <Input
          id="name"
          value={formData.name}
          onChange={(e) => onChange({ name: e.target.value })}
          placeholder="Enter policy type name"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={formData.description}
          onChange={(e) => onChange({ description: e.target.value })}
          placeholder="Enter policy type description"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="policy_line">Policy Line</Label>
        <Select 
          value={formData.policy_line_id} 
          onValueChange={(value) => onChange({ policy_line_id: value })}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select a policy line" />
          </SelectTrigger>
          <SelectContent>
            {isPolicyLinesLoading ? (
              <SelectItem value="">Loading...</SelectItem>
            ) : (
              policyLines?.map((line) => (
                <SelectItem key={line.id} value={line.id}>
                  {line.name}
                </SelectItem>
              ))
            )}
          </SelectContent>
        </Select>
      </div>

      <div className="flex justify-end space-x-2">
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">
          {mode === 'create' ? 'Create' : 'Update'} Policy Type
        </Button>
      </div>
    </form>
  );
};